import React, { Component } from 'react';
import { Redirect } from 'react-router';
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import withStyles from "@material-ui/core/styles/withStyles";
import Slide from '@material-ui/core/Slide';
import Button from "components/CustomButtons/Button";
import ButtonX from '@material-ui/core/Button';
import Snackbar from "components/Snackbar/Snackbar";
import Icon from "../components/Selfcare/Common/Icon";
import Version from "version";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import setNewPasswordPageStyle from "assets/jss/material-dashboard-pro-react/views/setNewPasswordPageStyle";

import { withTranslation } from 'react-i18next';
import compose from 'recompose/compose';

// dotNetify
import dotnetify from 'dotnetify';

import auth from "../auth";
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js';

var reactPlugin = new ReactPlugin();

const MySwal = withReactContent(Swal);

class SetNewPassword extends Component {
    constructor(props) {
        super(props);
        this.vm = dotnetify.react.connect("SetNewPassword", this, {
            headers: {
                Authorization: "Bearer " + auth.getAccessToken(),
                ClientVersion: Version.getVersion(),
                ServerToken: window.sessionStorage.ServerToken
            },
            exceptionHandler: _ => auth.signOut()
        });
        // Set up function to dispatch state to the back-end.
        this.dispatchState = state => this.vm.$dispatch(state);

        // we use this to make the card to appear after the page has been rendered
        this.state = {
            show: false,
            redirect: null,
            toUrl: null,
            snackbarOpen: false,
            snackbarMessage: '',
            Password: '',
            PasswordRepeat: '',
            Email: '',
            AcceptSendPasswordToEmail: false,
        };
        this.passwordInput = React.createRef();
        this.passwordRepeatInput = React.createRef();
        this.emailInput = React.createRef();
    }
    componentDidMount() {
        setTimeout(
            function () {
                this.setState({ show: true });
            }.bind(this),
            700
        );
    }

    UNSAFE_componentWillUpdate(nextProps, nextState) {
        if (!this.state.UnAuthorized && nextState.UnAuthorized) {
            auth.signOut();
        }
        if (!this.state.AlertPasswordChanged && nextState.AlertPasswordChanged) {
            if (this.hasLocalStorage() && localStorage.chRememberMe) {
                localStorage.chPassword = nextState.EncryptedPassword;
            }
            MySwal.fire({
                title: this.props.t('selfcare:notification.passwordischanged'),
                icon: 'success',
                confirmButtonColor: '#e91e63',
            }).then((result) => {
                this.setState({ redirect: true, toUrl: '/overview' });
            });
        }
        if (!this.state.AlertPasswordChangeFailed && nextState.AlertPasswordChangeFailed) {
            setTimeout(
                function () {
                    this.setState({ AlertPasswordChangeFailed: false });
                    this.setState({ snackbarOpen: true, snackbarMessage: this.props.t('selfcare:notification.passwordchangefailed') }); 
                    this.dispatchState({ AlertPasswordChangeFailed: false });
                }.bind(this),
                100
            );
        }
    }
    componentDidUpdate() {
        if (this.state.PasswordErrorText === undefined) {
            return;
        }

        if (this.state.PasswordErrorText !== '') {
            this.passwordInput.current.focus();
        }
        if (this.state.PasswordRepeatErrorText !== '') {
            this.passwordRepeatInput.current.focus();
        }
        if (this.state.EmailErrorText !== '') {
            this.emailInput.current.focus();
        }
    }
    componentWillUnmount() {
        this.vm.$destroy();
    }

    hasLocalStorage = function () {
        try {
            window.localStorage.setItem("__test", "data");
            window.localStorage.removeItem("__test");
        } catch (e) {
            return false;
        }
        return true;
    }

    handleChange = name => event => {
        this.dispatchState({ [name]: event.target.checked, ClearErrors: true });
    };

    navigateTo = url => {
        this.setState({ show: false });
        setTimeout(
            function () {
                this.setState({
                    toUrl: url,
                    redirect: true
                });
            }.bind(this),
            300
        );
    }

    render() {
        console.debug('SetNewPassword render');

        const { classes, t } = this.props;
        let { Password, PasswordRepeat, Email, show } = this.state;
        const hideSnackbar = _ => {
            this.setState({ snackbarOpen: false });
        }
        return (
            <div style={{ height: '100vh' }}>
                    <Snackbar open={this.state.snackbarOpen} color="rose" message={this.state.snackbarMessage} place="bc" close={true} closeNotification={hideSnackbar}/>
                    {this.state.redirect ? (<Redirect to={this.state.toUrl} />) : null}
                        <div style={{ backgroundColor: '#e91e63', color: '#FFF', padding: '20px' }}>
                            <GridContainer justify="center">
                                <GridItem xs={12} sm={10} md={8} lg={6}>
                                    <Icon name="lock" size={32} color="#FFFFFF" />
                                    <div style={{ fontSize: '20px', fontWeight: '700', maxWidth: '900px' }}>
                                    {t('selfcare:item.choose-personal-password')}.
                                    </div>
                                <div style={{ fontSize: '12px', paddingTop: '20px' }}><span dangerouslySetInnerHTML={{ __html: t('selfcare:info.personal-password') }} /></div>
                                </GridItem>
                            </GridContainer>
                        </div>
                        <div style={{ padding: '20px' }}>
                        <form onSubmit={(e) => { e.preventDefault(); this.dispatchState({ Password: this.state.Password, PasswordRepeat: this.state.PasswordRepeat, Email: this.state.Email, ClearErrors: true }); this.dispatchState({ ChangePassword: false }); }}>
                            <GridContainer direction="row" justify="center" alignItems="center">
                                <GridItem xs={12} sm={10} md={8} lg={6}>
                                    <b>{t('selfcare:title.select-a-new-password')}</b>
                                    <GridContainer>
                                        <GridItem xs={12} sm={6}>
                                            <FormControl fullWidth error={this.state.PasswordErrorText !== ''} className={classes.margin}>
                                                <InputLabel
                                                    classes={{
                                                        root: classes.cssLabel,
                                                        focused: classes.cssFocused,
                                                    }}
                                                    htmlFor="password"
                                                >
                                                    {t('selfcare:label.enter-new-password')}
                                            </InputLabel>
                                                <Input
                                                    classes={{
                                                        underline: classes.cssUnderline,
                                                    }}
                                                    id="password"
                                                    onChange={event => {
                                                        this.setState({ Password: event.target.value, PasswordErrorText: '', PasswordRepeatErrorText: '', EmailErrorText: '' });
                                                    }}
                                                    type="password"
                                                    value={Password}
                                                    color="secondary"
                                                    autoFocus
                                                    inputRef={this.passwordInput}
                                                />
                                                <FormHelperText id="password-error-text">{this.state.PasswordErrorText}</FormHelperText>
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={12} sm={6}>
                                            <FormControl fullWidth error={this.state.PasswordRepeatErrorText !== ''} className={classes.margin}>
                                                <InputLabel
                                                    classes={{
                                                        root: classes.cssLabel,
                                                        focused: classes.cssFocused,
                                                    }}
                                                    htmlFor="password-repeat"
                                                >
                                                    {t('selfcare:label.repeat-new-password')}
                                            </InputLabel>
                                                <Input
                                                    classes={{
                                                        underline: classes.cssUnderline,
                                                    }}
                                                    id="password-repeat"
                                                    onChange={event => {
                                                        this.setState({ PasswordRepeat: event.target.value, PasswordErrorText: '', PasswordRepeatErrorText: '', EmailErrorText: '' });
                                                    }}
                                                    type="password"
                                                    value={PasswordRepeat}
                                                    color="secondary"
                                                    inputRef={this.passwordRepeatInput}
                                                />
                                                <FormHelperText id="password-repeat-error-text">{this.state.PasswordRepeatErrorText}</FormHelperText>
                                            </FormControl>
                                        </GridItem>
                                        <GridItem xs={12} sm={6}>
                                            <FormControl fullWidth error={this.state.EmailErrorText !== ''} className={classes.margin}>
                                                <InputLabel
                                                    classes={{
                                                        root: classes.cssLabel,
                                                        focused: classes.cssFocused,
                                                    }}
                                                    htmlFor="email"
                                                >
                                                    {t('selfcare:label.enter-email')}
                                            </InputLabel>
                                                <Input
                                                    classes={{
                                                        underline: classes.cssUnderline,
                                                    }}
                                                    id="email"
                                                    onChange={event => {
                                                        this.setState({ Email: event.target.value, PasswordErrorText: '', PasswordRepeatErrorText: '', EmailErrorText: '' });
                                                    }}
                                                    type="email"
                                                    value={Email}
                                                    color="secondary"
                                                    inputRef={this.emailInput}
                                                />
                                                <FormHelperText id="email-error-text">{this.state.EmailErrorText}</FormHelperText>
                                            </FormControl>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={this.state.AcceptSendPasswordToEmail}
                                                        onChange={this.handleChange('AcceptSendPasswordToEmail')}
                                                        value="AcceptSendPasswordToEmail"
                                                    />
                                                }
                                                label={t('selfcare:label.email-can-receive-password')}
                                            />
                                            
                                        </GridItem>
                                    </GridContainer>
                                    <div style={{ paddingTop: '20px' }}>
                                        <Button type="submit" size="sm" variant="contained" color="rose">{t('selfcare:button.change-password')}</Button>
                                        <ButtonX size="small" onClick={(e) => { e.preventDefault(); this.dispatchState({ Password: this.state.Password, PasswordRepeat: this.state.PasswordRepeat, Email: this.state.Email, ClearErrors: true }); this.dispatchState({ ChangePassword: true }); }}>{t('selfcare:button.proceed-without-email')}</ButtonX>
                                        </div>
                                </GridItem>
                            </GridContainer>
                            </form>
                        </div>
            </div>
        );
    }
}
SetNewPassword.propTypes = {
};

export default compose(
    withStyles(setNewPasswordPageStyle),
    withTranslation(),
)(withAITracking(reactPlugin, SetNewPassword));